import axios from 'axios';
import { useNavigate } from 'react-router';

import { getApiUrl } from '../Utils/Helpers';
import { getToken, hasToken, removeToken } from '../Utils/Token';

export const useApi = () => {
  const navigate = useNavigate();
  const api = () => {
    return axios.create({
      baseURL: getApiUrl(),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${hasToken() ? getToken() : undefined}`,
      },
    });
  };

  const get = async (url, success, error, qeryString = {}, heaedrs = {}) => {
    await api()
      .get(url, {
        params: qeryString,
        heaedrs,
      })
      .then((response) => {
        success(response.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          return logout();
        } else if (err.response.status === 403) {
          return navigate('/403');
        } else {
          return error(err.response);
        }
      });
  };

  const post = async (
    url,
    data,
    success,
    error,
    fileUpload = false,
    heaedrs = {},
  ) => {
    let formData = new FormData();
    for (const property in data) {
      formData.append(property, data[property]);
    }
    await api()
      .post(url, fileUpload ? formData : data, {
        headers: fileUpload
          ? { ...heaedrs, 'Content-Type': 'multipart/form-data' }
          : heaedrs,
      })
      .then((response) => {
        success(response.data);
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          return logout();
        } else if (err.response.status === 403) {
          return navigate('/403');
        } else {
          return error(err.response);
        }
      });
  };

  const put = async (url, data, success, error, heaedrs = {}) => {
    await api()
      .put(url, data, {
        headers: heaedrs,
      })
      .then((response) => {
        success(response.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          return logout();
        } else if (err.response.status === 403) {
          return navigate('/403');
        } else {
          return error(err.response);
        }
      });
  };

  const destroy = async (url, success, error, heaedrs = {}) => {
    await api()
      .delete(url, {
        heaedrs,
      })
      .then((response) => {
        success(response.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          return logout();
        } else if (err.response.status === 403) {
          return navigate('/403');
        } else {
          return error(err.response);
        }
      });
  };

  const logout = () => {
    removeToken();
    return navigate('/');
  };

  return {
    get: (url, success, error, qeryString, heaedrs) =>
      get(url, success, error, qeryString, heaedrs),
    post: (url, data, success, error, heaedrs) =>
      post(url, data, success, error, heaedrs),
    put: (url, data, success, error, heaedrs) =>
      put(url, data, success, error, heaedrs),
    destroy: (url, success, error, heaedrs) =>
      destroy(url, success, error, heaedrs),
  };
};
